import Episode01 from "./Episode01";
import Episode02 from "./Episode02";

export default {
  ...Episode01,
  ...Episode02,
};
